import type { InsightCalloutBlock as InsightCalloutBlockType } from '../types';

// ─────────────────────────────────────────────
// InsightCalloutBlock — 关键洞察高亮框
// Figma: node 10364-98719
// ─────────────────────────────────────────────
export function InsightCalloutBlock({ block }: { block: InsightCalloutBlockType }) {
  if (!block.text) return null;
  return (
    <div className="flex flex-row items-stretch gap-3 bg-[#F8F8F7] rounded-[8px] p-3 w-full">
      {/* 左侧竖线 */}
      <div className="w-[4px] flex-shrink-0 bg-[#262626] rounded-[2px]" />
      <p className="flex-1 text-[14px] font-normal text-[#525252] leading-[1.5] tracking-[0.005em]">{block.text}</p>
    </div>
  );
}
